import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {BookingFormType} from "../../../store/booking/forms";
import {localize} from "../../../../../common/libs";
import {SnackbarType} from "../../../../../stores/common";
import style from "./../style.module.css";
import {useHistory} from "react-router-dom";

const DeleteMenuItemForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const {bookingStore, generalStore} = useStores();
    const history = useHistory();
    const forms = bookingStore.forms;
    const {open, current} = forms.forms[BookingFormType.deleteBookingItem];
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (!current) return null;

    const submitDelete = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (!current) return;
        const res = await bookingStore.removeMenuItem(current.menuId, current.id);
        const menuId = current.menuId;
        if (res.err) {
            generalStore.showSnackbar({
                type: SnackbarType.error,
                title: t("menu:menuEditor.errorWhileDeletingPosition")
            })
        } else {
            generalStore.showSnackbar({
                type: SnackbarType.success,
                title: t("menu:menuEditor.positionSuccessfullyDeleted")
            });
            bookingStore.forms.closeForm(BookingFormType.deleteBookingItem);
            history.push(`/menus/booking/${menuId}/view`);
        }
    }


    return (
        <Dialog
            open={open}
            onClose={() => {
                bookingStore.forms.closeForm(BookingFormType.deleteBookingItem)
            }
            }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" className={style.deleteContent}>
                {t("menu:deleteMenuItem")}
            </DialogTitle>
            <DialogContent className={style.deleteContent}>
                {t("menu:youGoingRemoveMenuItem")} '{localize(current.data.name)}'.
                <br/>
                {t("menu:itIsUndone")}

            </DialogContent>

            <DialogActions>
                <div style={{marginBottom: "30px"}}>
                    <Button
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            bookingStore.forms.closeForm(BookingFormType.deleteBookingItem)
                        }}
                        color="primary">
                        {t("general:cancel")}
                    </Button>
                    <Button
                        color="default"
                        onClick={submitDelete}
                    >
                        {t("menu:modifiersSet.wantDelete")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteMenuItemForm);


